import React from "react";
import Progress7Svg from "../../../assets/svgicons/progress-bar/progress_bar_7.svg";

const Progress7 = (props) => {
  return <img src={Progress7Svg} alt="Progress 7" {...props} />;
};

export default Progress7;
